const MenuItems = [
    {
        label: 'home',
        link: '/',
        hasSubMenu: false,
        showOnlyinFA: true,
    },
    {
        label: 'about_us',
        hasSubMenu: true,
        submenu: [
            { label: 'market_overview', defaultTab: 'market_overview', link: '/IrenexAtGlance', component: "IrenexAtGlance" },
            { label: 'CEO_message', link: '/CEOMessage', component:"CEOMessage" },            
            { label: 'board_of_directors', link: '/BoardOfDirectors', component: "BoardOfDirectors" },
            { label: 'specialized_committee', link: '/SpecializedCommittee', component: "SpecializedCommittee" },
            { label: 'statute', link: '/IrenexStatute', showOnlyinFA: true, component: "IrenexStatute" },
            
            {
                label: 'codal_reports',
                link: 'https://codal.ir/ReportList.aspx?search&Symbol=%D8%A7%D9%86%D8%B1%DA%98%DB%8C&LetterType=-1&Isic=671203&AuditorRef=-1&PageNumber=1&Audited&NotAudited&IsNotAudited=false&Childs&Mains&Publisher=false&CompanyState=0&Category=-1&CompanyType=1&Consolidatable&NotConsolidatable',
                showOnlyinFA: true, component: "CodalReports"
            },
            { label: 'organizational_structure', link: '/OrganizationChart', component: "OrganizationChart" },
            { label: 'trading_fees', link: '/TradesFee', component:'TradesFee' },
            { label: 'corporate_governance', link: '/CorporateGovernance', showOnlyinFA: true, component: "CorporateGovernance" },
            /*{ label: 'social_responsibility', link: '/SocialResponsibility', showOnlyinFA: true, component: "SocialResponsibility" },*/
            { label: 'SustainabilityReport', link: '/SustainabilityReport', showOnlyinFA: true, component: "SustainabilityReport" },
            { label: 'calendar', link: '/Calendar', showOnlyinFA: true, component: "Calendar" },
        ],
    },
    {
        label: 'market',
        hasSubMenu: true,
        submenu: [
            { label: 'physical_market_dashboard', link: '/PhysicalMarket/TradeBoard', component: "PhysicalMarket" },
            { label: 'electricity_market_dashboard', link: '/PowerMarket/TradeBoard', component: "PowerMarket" },
            { label: 'derivatives_market_dashboard', link: '/DerivativeMarket/TradeBoard', component: "DerivativeMarket" },
            { label: 'other_securities_dashboard', link: '/OtherTradableSecurities/TradeBoard', component: "OtherTradableMarket" },            
            { label: 'statistical_reports', link: '/Market/Report', showOnlyinFA: true, component: "Report" },            
            { label: 'registered_brokers', link: '/Market/Brokers', component: "Brokers" },
            { label: 'market_maker', link: '/Market/Brokers', component: "MarketMakers" },
        ],
    },
    {
        label: 'reception',
        hasSubMenu: true,
        submenu: [
            { label: 'reception_overview', link: '/Listing/ListingIntroduction', component:"ListingIntroduction" },
            { label: 'prospectuses', link: '/Listing/Prospectus/PhysicalProspectus', showOnlyinFA: true, component:"Prospectus"},
            /*{ label: 'کالاها و اوراق بهادار پذیرفته‌شده', link: '/Listing/Instruments' },*/
            { label: 'supply_statements', link: '/Listing/SupplyStatementsList', showOnlyinFA: true, component:"SupplyStatementsList"},
            { label: 'product_analysis', link: '/Analyze', component: "Analyze", showOnlyinFA: false },
            { label: 'consultant_ranking', link: '/Listing/RankingOfListingConsultants', showOnlyinFA: true, component: "RankingOfListingConsultants" },
            { label: 'inventories', link: '/Listing/Inventories', showOnlyinFA: true, component: "Inventories" },
            { label: 'offered_products', link: '/ValueChain/Commodities', showOnlyinFA: true, component: "Commodities" },
            { label: 'associate_suppliers_producers', link: '/ValueChain/Producers', showOnlyinFA: true, component: "Producers" },
        ],
    },
    {
        label: 'media',
        hasSubMenu: true,
        showOnlyinFA: false,
        submenu: [
            { label: 'news', link: '/Media/News', component: "News" },
            { label: 'visual_reports', link: '/Media/VisualReports', component: "VisualReports", showOnlyinFA: true },
            { label: 'multimedia', link: '/Media/Multimedia', component: "Multimedia", showOnlyinFA: true },            
        ],
        
    },
    {
        label: 'regulations',
        link: '/Rules',
        hasSubMenu: false,
        showOnlyinFA: true,
    },
    {
        label: 'systems',
        link: '/',
        hasSubMenu: true,
        /*comingSoon: true,*/
        showOnlyinFA: true,
        submenu: [
            { label: 'dibaSystem', link: '/', showOnlyinFA: true, component: "DibaSystem" },
            { label: 'integratedEnergyGateway', link: '/', showOnlyinFA: true, component: "IntegratedEnergyGateway" },
        ],
    },
];

export default MenuItems;